import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default assets for the Site Picker component.
 */
export const defaultSitePickerAssets = {
    noSitesFoundIconName: 'location-info-message',
    failedToLoadDataIconName: 'generic-error-message',
    removeSelectedSiteIconName: 'cross'
};
export const sitePickerAssetsValidator = Validator.object({
    noSitesFoundIconName: nonEmptyStringValidator,
    failedToLoadDataIconName: nonEmptyStringValidator,
    removeSelectedSiteIconName: nonEmptyStringValidator
});
